export default {
  changeAutoscheduleData(state, { field, key, value }) {
    state[field][key] = value
  },
  changeCommonData(state, { storageField, key, value }) {
    if (storageField !== '') {
      localStorage.setItem(storageField, JSON.stringify(value))
    }
    state.commonData[key] = value
  },
  changeGraphsSettings(state, { key, value }) {
    state.graphsSettings[key] = value
  },
  changeItemInSchedules(state, { employer, stats, employerIndex }) {
    // меняем расписание у мастера по конкретным дням
    Object.keys(employer.schedules).forEach(key => {
      const timeDifference = employer.timeSum

      state.forecasting.scheduleData[employerIndex].schedules[key] = employer.schedules[key]

      // если статус поменялся на common, то добавляем время к общей сумме мастера
      if (employer.schedules[key].every(item => item.type === 'common')) {
        state.forecasting.scheduleData[employerIndex].timeSum += timeDifference
      }
      // если поменялся на unaccepted, то вычитаем из общего времени мастера все смены за этот день
      else if (employer.schedules[key].every(item => item.type === 'unaccepted')) {
        employer.schedules[key].forEach(item => {
          state.forecasting.scheduleData[employerIndex].timeSum -= item.time
        })
      }
    })
    // меняем статистику за конкретные дни
    Object.keys(stats).forEach(key => {
      state.forecasting.daysData[key] = stats[key]
    })
  },
  removedAllApprovedForceInDay(state, date) {
    state.forecasting.scheduleData.forEach(employer => {
      const schedules = employer.schedules[date]

      if (schedules) {
        schedules.forEach(item => {
          if (item.type === 'force-master-approved') {
            item.type = 'force-master'
          }
        })
      }
    })
  },
  pushScheduleItemDataForForecasting(state) {
    const { daysData } = state.forecasting

    state.forecasting.schedulesDataForGraph = Object.keys(daysData).map(key => Math.round(daysData[key].overall / 3600))
  },
}
